const Card = ({ imgURL, title, details, techStack, linkDemo, linkDeploy, linkCode }) => {
    return (
        <div className="card bg-color cardHover overflow-hidden">
            <img src={imgURL} className="card-img-top imgHover" alt="projectImage" />
            <div className="card-body">
                <div className="contentHeight">
                    <h3 className="card-title mb-3">{title}</h3>
                    <p className="card-text mb-4">{details}</p>
                    <p className="card-text"><b>Tech Stack: </b>{techStack}</p>
                </div>
                <div>
                    <a href={linkDemo} target="_blank" rel="noreferrer" className="btn btn-outline-danger mb-2">Video Demo</a>
                    <a href={linkDeploy} target="_blank" rel="noreferrer" className="btn btn-outline-warning mx-2 mb-2">Deployment</a>
                    <a href={linkCode} target="_blank" rel="noreferrer" className="btn btn-outline-info mb-2">Source Code</a>
                </div>
            </div>
        </div>
    );
};


export const Projects = () => {
    return (
        <div id="projects" className="container top-margin">
            <h1 className="my-4">Projects</h1>
            <div className="gridFormatCards">

                <Card
                    imgURL={"/facebook-clone.png"}
                    title={"Facebook Clone"}
                    details={"This is a clone of “Facebook” in which I implemented some cool functionalities like create post, change bio and other detail, update profile and cover pic and many more."}
                    techStack={"React, Chakra UI, CSS, Node JS, Express, MongoDB"}
                    linkDemo={"https://drive.google.com/file/d/1N1_wQneqCG0_s0e-d2OkvAHg3eSqeNKJ/view?usp=sharing"}
                    linkDeploy={"https://facebook-cloners.vercel.app/login"}
                    linkCode={"https://github.com/m-sehrawat/Facebook-Clone"}
                />

                <Card
                    imgURL={"/lybrate-front.png"}
                    title={"Lybrate Clone"}
                    details={"This website is a clone of “Lybrate.com” in which I implemented some cool functionalities like Real time search using debounce, data fetching from JSON mock server and many more."}
                    techStack={"HTML, CSS, Bootstrap, Advanced JS, Node JS, Express, MongoDB"}
                    linkDemo={"https://drive.google.com/file/d/10dzxdQXBFoev6XhebczGTo7pruGhu-E1/view"}
                    linkDeploy={"https://m-sehrawat.github.io/Lybrate-Website-Clone-Version-2.0/frontend/landingpage.html"}
                    linkCode={"https://github.com/m-sehrawat/Lybrate-Website-Clone-Version-2.0"}
                />

                <Card
                    imgURL={"/adidas-front.png"}
                    title={"Adidas Clone"}
                    details={"This website is a clone of “Adidas.com” in which I implemented some cool functionalities product sorting and multiple filters, add to cart function, the coupon discount and many more."}
                    techStack={"HTML, CSS, Advanced JS"}
                    linkDemo={"https://drive.google.com/file/d/1eFx1BIjs9sYmcSn5ju8oaDyfOJE1PwrE/view?usp=sharing"}
                    linkDeploy={"https://m-sehrawat.github.io/Adidas-Website-Clone/Project%20Files/adidas_home_page.html"}
                    linkCode={"https://github.com/m-sehrawat/Adidas-Website-Clone"}
                />
            </div>
        </div>
    );
};